<div class="container" (click)="onClick()">
  <img src="assets/images/trash-icon.svg" />
  <span>Remover</span>
</div>
